import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-favorite-save',
    templateUrl: './favorite-save.component.html',
    styleUrls: ['./favorite-save.component.scss'],
    standalone: false
})
export class FavoriteSaveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
